export const players = [
  { 'name': 'Always Right', 'avatar': '/emoji/1f99d.svg' },
  { 'name': 'Wrong Every Time', 'avatar': '/emoji/1f496.svg' },
  { 'name': 'Justin', 'avatar': '/emoji/1f63a.svg' },
  { 'name': 'Susan', 'avatar': '/emoji/1f640.svg' },
  { 'name': 'Ashley', 'avatar': '/emoji/1f643.svg' },
  { 'name': 'Kathleen Kathleen', 'avatar': '/emoji/1f922.svg' },
  { 'name': 'Elizabeth David', 'avatar': '/emoji/1f63e.svg' },
  { 'name': 'Justin', 'avatar': '/emoji/1f631.svg' },
  { 'name': 'Angela', 'avatar': '/emoji/1f3d4.svg' },
  { 'name': 'Linda', 'avatar': '/emoji/1f47e.svg' },
  { 'name': 'George', 'avatar': '/emoji/1f52d.svg' },
  { 'name': 'Joshua', 'avatar': '/emoji/1f601.svg' },
  { 'name': 'Ryan', 'avatar': '/emoji/1f337.svg' },
  { 'name': 'Shirley', 'avatar': '/emoji/1f31c.svg' },
  { 'name': 'SUPER STEVEN', 'avatar': '/emoji/1f9c2.svg' },
  { 'name': 'Sharon', 'avatar': '/emoji/1f60c.svg' },
  { 'name': 'Nicole Scott', 'avatar': '/emoji/1f628.svg' },
  { 'name': 'Mark', 'avatar': '/emoji/1f37e.svg' },
  { 'name': 'Brian', 'avatar': '/emoji/2623.svg' },
  { 'name': 'Dorothy', 'avatar': '/emoji/1f9f2.svg' }
]

const names = [ // 300 at random
  'Jaii', 'Rhudi', 'Aronas', 'Conal', 'Cabhan',
  'Cadan', 'Cain', 'Arfin', 'Bjorn', 'Alan',
  'Callahan', 'Ameer', 'Buddy', 'Aryankhan', 'Anubhav',
  'Alistar', 'Ari', 'Caelan', 'Briaddon', 'Bill',
  'Ashlee-jay', 'Ashton', 'Brendan', 'Averon', 'Ashton-Lloyd',
  'Atapattu', 'Cade', 'Breogan', 'Aonghus', 'Caley',
  'Areez', 'Callan-Adam', 'Brandon', 'Brendyn', 'Cailaen',
  'Charles', 'Ala', 'Arnav', 'Aryan', 'Christoph',
  'Antonio', 'Craig', 'Crawford', 'Anndra', 'Andrei',
  'Broghan', 'Danniel', 'Arnab', 'Anish', 'Allen',
  'Chevy', 'Angelo', 'Cruz', 'Brunon', 'Calley',
  'Artem', 'Dalton', 'Bo', 'Marc', 'Oban',
  'Ojima-Ojo', 'Dale', 'Kendyn', 'Manus', 'Keison',
  'Basher', 'Kenzo', 'Kadyn', 'Hassanali', 'Bevin',
  'Gurdeep', 'Cal', 'Aleksandrs', 'Altyiab', 'Ivar',
  'Oliwier', 'Hamza', 'Herbert', 'Ikechukwu', 'Nikodem',
  'Izaak', 'Humza', 'Orson', 'Irvin', 'Cairn',
  'Calder', 'Madaki', 'Kasey', 'Mikolaj', 'Nelson',
  'Andreas', 'Mathuyan', 'Jacques', 'Barkley', 'Jack-James',
  'Firaaz', 'Daksh', 'Ian', 'Orin', 'Kealon',
  'Jaii', 'Rhudi', 'Aronas', 'Conal', 'Cabhan',
  'Cadan', 'Cain', 'Arfin', 'Bjorn', 'Alan',
  'Callahan', 'Ameer', 'Buddy', 'Aryankhan', 'Anubhav',
  'Alistar', 'Ari', 'Caelan', 'Briaddon', 'Bill',
  'Ashlee-jay', 'Ashton', 'Brendan', 'Averon', 'Ashton-Lloyd',
  'Atapattu', 'Cade', 'Breogan', 'Aonghus', 'Caley',
  'Areez', 'Callan-Adam', 'Brandon', 'Brendyn', 'Cailaen',
  'Charles', 'Ala', 'Arnav', 'Aryan', 'Christoph',
  'Antonio', 'Craig', 'Crawford', 'Anndra', 'Andrei',
  'Broghan', 'Danniel', 'Arnab', 'Anish', 'Allen',
  'Chevy', 'Angelo', 'Cruz', 'Brunon', 'Calley',
  'Artem', 'Dalton', 'Bo', 'Marc', 'Oban',
  'Ojima-Ojo', 'Dale', 'Kendyn', 'Manus', 'Keison',
  'Basher', 'Kenzo', 'Kadyn', 'Hassanali', 'Bevin',
  'Gurdeep', 'Cal', 'Aleksandrs', 'Altyiab', 'Ivar',
  'Oliwier', 'Hamza', 'Herbert', 'Ikechukwu', 'Nikodem',
  'Izaak', 'Humza', 'Orson', 'Irvin', 'Cairn',
  'Calder', 'Madaki', 'Kasey', 'Mikolaj', 'Nelson',
  'Andreas', 'Mathuyan', 'Jacques', 'Barkley', 'Jack-James',
  'Firaaz', 'Daksh', 'Ian', 'Orin', 'Kealon',
  'Veeran', 'Briaddon', 'Usman', 'Honey',
  'Sanjay', 'Haseeb', 'Kaiden', 'Saad',
  'Conlin', 'Aulay', 'Arafat', 'Leroy',
  'Malakai', 'Julian', 'Sergio', 'Alan',
  'Colm', 'Kern', 'Zaineddine', 'Scot',
  'Shane', 'Antoine', 'Bradan', 'Roary',
  'Kaelin', 'Fergus', 'Kallan', 'Sharland',
  'Finnean', 'Kash', 'Danyil', 'Kacey',
  'Bracken', 'Niraj', 'Kenzi', 'Lenny',
  'Edwin', 'Joojo', 'Aryian', 'Davy',
  'Reno', 'Macy', 'Amani', 'Olaoluwapolorimi',
  'Quinlan', 'Geoffrey', 'Raunaq', 'Ashley',
  'Kieran', 'Nayan', 'Orrin', 'Amro',
  'Angelo', 'Raith', 'Wesley', 'Thorfinn',
  'Lyle', 'Dyllan', 'Dareh', 'Darcy',
  'Cesare', 'Will', 'Joshiah', 'JJ',
  'Carl', 'Rikki', 'Zubayr', 'Hashim',
  'Iain', 'Rory', 'Ikemsinachukwu', 'Darragh',
  'Alexx', 'Maddison', 'Sanaullah', 'Ole',
  'Vrishin', 'Taylor-Jay', 'Farren', 'Jebadiah',
  'Patrikas', 'Keenan', 'Kynan', 'Tayo',
  'Tamiem', 'Keigan', 'Alastair', 'Ryaan',
  'Marvellous', 'Elliott', 'Caedyn', 'Paolo',
  'Oliwier', 'Jac', 'Abdur', 'Phinehas',
  'Sean-Ray', 'Dilano', 'Boyd', 'Maitlind'
]

const emojiFiles = () => {
  const keys = require.context('~/static/emoji', false, /\.[jepnsvg]{3}$/).keys()
  return keys.map(key => '/emoji' + key.replace(/^\./, ''))
}
const emoji = emojiFiles()

const allPlayers = () => {
  return names.map((name, index) => {
    return {
      name,
      id: -1000 - index,
      avatar: emoji[index]
    }
  })
}

export const playerList = allPlayers()
